/**
 * Student-app wiring of the shared idle-safety ping (shared-ui/messages):
 * signed in, and NOT in test mode (an active solving session / question / live
 * duel) — proactive UI is suppressed there anyway, and flushed on exit.
 *
 * See docs/FeatureDesigns/duels-invite-smoothing-plan.md.
 */

import { useMessagePing as useSharedMessagePing } from '@shared-ui/messages';
import { apiClient } from '../api/config';
import { isTestModePath } from './testMode';
import { getStoredToken } from '../api/auth';

const ping = () => apiClient.fetchApi('/messages/ping');
const isActive = () => !!getStoredToken() && !isTestModePath(window.location.pathname);

export function useMessagePing(): void {
  useSharedMessagePing(ping, isActive);
}
